<template>
  <div class="navbar">
    <nav class="nav" @click="click">
      <label  for="file" title="Upload" role="button" v-if="!data.loaded"> <md-icon class="classIcon">cloud_upload</md-icon> </label>
      <button type="button" class="nav__button" data-action="restore" title="Atras (Ctrl + Z)" v-if="data.cropped"> <md-icon class="classIcon">undo</md-icon> </button> 
      <button type="button" class="nav__button nav__button--danger" data-action="remove" title="Borrar (supr)" v-if="data.loaded && !data.cropping"> <md-icon class="classIcon">delete</md-icon> </button>
      <button type="button" class="nav__button nav__button--danger" data-action="clear" title="Cancelar (Esc)" v-if="data.cropping"> <md-icon class="classIcon">close</md-icon> </button>
      <button type="button" class="nav__button nav__button--success" data-action="crop" title="OK (Enter)" v-if="data.cropping">  <md-icon class="classIcon"> check</md-icon> </button>
      <md-checkbox v-if="data.loaded" class="checkCustomer" v-model="customerChek">El cliente Puede ver</md-checkbox>
      
      <!-- <a 
      class="nav__button nav__button--success" 
      title="Download" 
      :download="data.name" 
      :href="data.url" 
      v-if="downloadable && data.loaded">
        <span class="fa fa-download"></span>
      </a> -->

      <!-- <a class="nav__button" href="https://github.com/fengyuanchen/photo-editor" title="View on GitHub"><span class="fa fa-github"></span></a> -->
    </nav>
  </div>
</template>

<script>
  export default {
    name:'navbar',
    data() {
      return {
        customerChek: false,
        downloadable: typeof document.createElement('a').download !== 'undefined',
      };
    },
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      click({ target }) {
        const action = target.getAttribute('data-action') || target.parentElement.getAttribute('data-action');
        if (action) {
          this.$emit('change', action);
        }
      },
    },
  };
</script>

<style langs="scss" scoped>
  .navbar {
    float: right;
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    margin-left: 80px;
    border: 1px solid transparent;
  }

  .checkCustomer{
    cursor: pointer;
    float: right;
    height: 3rem;
    line-height: 3rem;
    margin-left: 50px;
    margin-top: 6px;
    
  }

  .classIcon {
    background-color: transparent;
    border-width: 0;
    color: rgb(228, 0, 0) !important; 
    cursor: pointer;
    display: block;
    float: left;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    width: 3rem;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: #0074d9;
      color: #fff;
    }
  }

  .nav__button {
    background-color: transparent;
    border-width: 0;
    color: rgb(228, 0, 0); 
    cursor: pointer;
    display: block;
    float: left;
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    width: 3rem;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: #0074d9;
      color: #fff;
    }
  }
  .nav--success:hover {
    background-color: #2ecc40;
  }
  .nav--danger:hover {
    background-color: #ff4136;
  }
</style>


// WEBPACK FOOTER //
// src/components/Outputs/Images/PhotoEditor/components/navbar.vue